import React from 'react';
import { applyAutoStretch } from 'components/report-content/components/dataset/index';
import IconMi from 'components/common/icon/IconMi';
import { Button } from '@mui/material';
import useBundleTranslation from 'i18n';
import type { ComponentUpdateProps, ComponentSettingsPivot } from '@report-content';

export default function ResetPivotColumnsSize({
    component,
    updateBlockSettings,
}: ComponentUpdateProps<ComponentSettingsPivot>) {
    const { t } = useBundleTranslation();
    const handleClick = () => {
        updateBlockSettings(applyAutoStretch(component.settings, component.datasetRendererBlockComponentId));
    };

    return (
        <Button
            disabled={component.settings.autoStretch}
            variant="text"
            startIcon={<IconMi icon="columns" />}
            onClick={handleClick}
        >
            {t('reset_columns')}
        </Button>
    );
}
